export function addRefererParam(
  url: string,
  moduleReferer?: string | null,
  landingReferer?: string | null
): string {
  const referer = (moduleReferer ?? '').trim() || (landingReferer ?? '').trim();
  if (!referer) return url;

  const [baseUrl, queryParams = ''] = url.split('?');
  const qParamWithRef = queryParams ? `${queryParams}&ref=${referer}` : `ref=${referer}`;

  return `${baseUrl}?${qParamWithRef}`;
}
